/* STEP 3 combined card (owner 27-Oct-2026 10:19) — B4: a discrepancy difference with no clearly trivial set in 105(a) is not
   rated (was Medium); B6: firm report formats refuse a US-order date. EN + AR. Loaded by the generated index (STEP 2 · B2). */
export const I18N_S3C = {
  en: {
    s3c: {
      riskNotRated: "Not rated – clearly trivial not set",
    },
  },
  ar: {
    s3c: {
      riskNotRated: "غير مصنَّف – لم يُحدَّد الحد غير المؤثر بوضوح",
    },
  },
};

export default I18N_S3C;
